new Swiper('.categories-mobile.swiper', {
  slidesPerView: 4,
  spaceBetween: 12,
  loop:true,
autoplay: {
  delay: 3000,
  disableOnInteraction: false,
},
  centeredSlides: false,
  loop: false,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    1200: { slidesPerView: 4, spaceBetween: 5 },
    1024: { slidesPerView: 3, spaceBetween: 5 },
    767:  { slidesPerView: 3, spaceBetween: 5 },
    320:  { slidesPerView: 1.5, spaceBetween: 5 },
  },
});